import React from "react";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { useTranslation } from "react-i18next";
import { getFeatureFlags, toggleInvoiceCreationFeatureFlag } from "../service/weexpertService";
import { Switch } from "@/components/ui/switch";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

const SettingsPage = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { data: flagsData, isLoading } = useQuery({
    queryKey: "featureFlags",
    queryFn: getFeatureFlags,
  });

  const toggleMutation = useMutation({
    mutationFn: toggleInvoiceCreationFeatureFlag,
    onSuccess: () => {
      queryClient.invalidateQueries("featureFlags");
    },
  });

  const flags = flagsData?.data ?? [];
  const invoiceCreationFlag = flags.find(
    (flag) => flag.key === "invoice_creation_feature"
  );
  const isInvoiceCreationEnabled = invoiceCreationFlag?.enabled ?? false;

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <Loader2 className="w-6 h-6 animate-spin" />
      </div>
    );
  }

  return (
    <div className="p-6 max-w-2xl">
      <h1 className="text-2xl font-bold mb-6">{t("settings:title")}</h1>

      <Card>
        <CardHeader>
          <CardTitle>{t("settings:invoice_creation")}</CardTitle>
          <CardDescription>
            {t("settings:invoice_creation_description")}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex items-center space-x-3">
            <Switch
              checked={isInvoiceCreationEnabled}
              disabled={toggleMutation.isLoading}
              onCheckedChange={() => toggleMutation.mutate()}
            />
            <Label>
              {isInvoiceCreationEnabled
                ? t("common:active")
                : t("common:unactive")}
            </Label>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SettingsPage;
